import {shopsProfileJson} from "../../profile";

export const addItemsToCart = (data = {},count) => {
    if (Object.keys(data).length > 0) {
        data["id"] = guidGenerator()
        data["description"] = null
        cartItemsJson.payload.push(
            {...data}
        )
        cartItemsJson.meta.count = Object.keys(cartItemsJson.payload).length
        cartItemsJson.meta.total = Object.keys(cartItemsJson.payload).length
        shopsProfileJson.payload.cart.itemsCount =  Object.keys(cartItemsJson.payload).length
    }else
    {
        shopsProfileJson.payload.cart.itemsCount = count
    }


}

export const deleteCartItems = (ids = [], all = false) => {
    if (ids.length > 0) {
        const newList = cartItemsJson.payload.filter((item) => ids.indexOf(item.id) === -1)
        cartItemsJson.payload = newList
    }
    if (all || cartItemsJson.payload.length === 0) {
        updateCartItems(false, true)
        shopsProfileJson.payload.cart.itemsCount = 0
    }
}
export const updateCartItems = (addBulkResponse = false, resetData = false) => {
    if (resetData) {
        cartItemsJson = {
            "payload": [],
            "meta": {
                "count": 0,
                "currentPage": 1,
                "lastPage": 1,
                "nextPageUrl": null,
                "pageSize": 10,
                "total": 0
            },
            "message": ""
        }
    }

    if (addBulkResponse)
        cartItemsJson = cartItemsBulkJson
}


export const cartItemsJobJson = {
    "data": {
        "id": "6379317b6166995ac612fbc1",
        "user_id": 11,
        "count_rows": 200,
        "residue": 0,
        "status": "DONE",
        "updated_at": "2022-11-19T19:42:05.963000Z",
        "created_at": "2022-11-19T19:41:47.913000Z"
    }
}
export let cartItemsJson = {
    "payload": [],
    "meta": {
        "count": 0,
        "currentPage": 1,
        "lastPage": 1,
        "nextPageUrl": null,
        "pageSize": 10,
        "total": 0
    },
    "message": ""
}
export const shippingDetailsPostJson = {
    "payload": [
        {
            "id": "cc353105-a00c-4446-b900-8d9e13c82bbe",
            "sender": {
                "firstName": "dsfs",
                "lastName": "ccc",
                "phone": "09179098741",
                "nationalCode": "2291397230",
                "postalCode": "1236584258",
                "cityId": "2301",
                "address": "استان تهران، تهران، استاد معین، میدان آزادی",
                "plate": "",
                "unit": "",
                "latitude": 35.69858282447701,
                "longitude": 51.33645057678223,
                "saveAddressAs": null
            },
            "receiver": {
                "firstName": "dsfs",
                "lastName": "ccc",
                "phone": "09179098741",
                "nationalCode": "2291397230",
                "postalCode": "1236584258",
                "cityId": "2301",
                "address": "استان تهران، تهران، استاد معین، میدان آزادی",
                "plate": "",
                "unit": "",
                "latitude": 35.69858282447701,
                "longitude": 51.33645057678223,
                "saveAddressAs": null
            },
            "parcels": [
                {
                    "boxSize": "584de130-7c6c-44ca-9388-9179c1988ea8",
                    "content": "zxx",
                    "value": {
                        "amount": 34,
                        "currency": "IRT"
                    },
                    "weight": {
                        "value": 34,
                        "unit": "G"
                    },
                    "_id": {
                        "$oid": "63a41f8fa0758b62146be844"
                    }
                }
            ]
        },
        {
            "id": "b0a8078d-fa48-4075-9bc9-9c1f39806d99",
            "sender": {
                "firstName": "dsfs",
                "lastName": "ccc",
                "phone": "09179098741",
                "nationalCode": "2291397230",
                "postalCode": "1236584258",
                "cityId": "2301",
                "address": "استان تهران، تهران، استاد معین، میدان آزادی",
                "plate": "",
                "unit": "",
                "latitude": 35.69858282447701,
                "longitude": 51.33645057678223,
                "saveAddressAs": null
            },
            "receiver": {
                "firstName": "dsfs",
                "lastName": "ccc",
                "phone": "09179098741",
                "nationalCode": "2291397230",
                "postalCode": "1236584258",
                "cityId": "2301",
                "address": "استان تهران، تهران، استاد معین، میدان آزادی",
                "plate": "",
                "unit": "",
                "latitude": 35.69858282447701,
                "longitude": 51.33645057678223,
                "saveAddressAs": null
            },
            "parcels": [
                {
                    "boxSize": "584de130-7c6c-44ca-9388-9179c1988ea8",
                    "content": "sdasd",
                    "value": {
                        "amount": 34,
                        "currency": "IRT"
                    },
                    "weight": {
                        "value": 324,
                        "unit": "G"
                    },
                    "_id": {
                        "$oid": "63a823e91a66091bf95dfc58"
                    }
                }
            ]
        }
    ],
    "meta": {
        "count": 2,
        "currentPage": 1,
        "lastPage": 1,
        "nextPageUrl": null,
        "pageSize": "10",
        "total": 2
    },
    "message": ""
}
export const shippingDetailsJson = (id)=>{
    let json = {}
    if(id === "79bd52bb-a4fe-45cc-9fa8-779349e192f4" || id === "527e5122-f085-47a6-b20f-560fd506ddc1")
        json = {
            "payload": [
                {
                    "title": "شرکت ملی پست (پیشتاز) ",
                    "value": "post",
                    "imgLink": "https://staging.podro.com/logos/postLogo.png"
                }
            ],
            "message": ""
        }
    if(id === "0d8e0891-e187-4b64-86f8-6a9b29577e4a" || id === "464e4018-7e22-4d35-8490-cbad09bdd460")
        json = {
            "payload": [
                {
                    "title": "لینک اکسپرس ",
                    "value": "link",
                    "imgLink": "https://staging.podro.com/logos/linkLogo.png"
                }
            ],
            "message": ""
        }
    if(id === "131dcf4f-4d3d-486b-b9d1-69336bda8c8c")
        json = {
            "payload": [
                {
                    "title": "پادرو اکسپرس ",
                    "value": "podex",
                    "imgLink": "https://staging.podro.com/logos/podroExpress.png"
                }
            ],
            "message": ""
        }
    if(id === "16e7c4bb-bb77-44cc-a414-1c5fe5eab3d5")
        json = {
            "payload": [
                {
                    "title": "اسپید ",
                    "value": "speed",
                    "imgLink": "https://staging.podro.com/logos/speedLogo.png"
                }
            ],
            "message": ""
        }
    if(id === "8e01171b-5727-474f-8291-e319a472aaa8")
        json = {
            "payload": [
                {
                    "title": "پیشروپست ",
                    "value": "pishropost",
                    "imgLink": "https://staging.podro.com/logos/pishropostLogo.png"
                }
            ],
            "message": ""
        }
    if(id === "81b84e42-b229-4f2f-ad8f-f1d09e3e13ee")
        json = {
            "payload": [
                {
                    "title": "ندکس ",
                    "value": "nedex",
                    "imgLink": "https://staging.podro.com/logos/nedexLogo.png"
                }
            ],
            "message": ""
        }
    if(id === "b31dc5c2-b570-49ef-ade4-f4291a2ae9a0" || id === "5f2972f5-21d9-4ed2-b706-abf584e11d06")
        json = {
            "payload": [
                {
                    "title": "چاپار ",
                    "value": "chapar",
                    "imgLink": "https://staging.podro.com/logos/chaparLogo.png"
                }
            ],
            "message": ""
        }
    if(id === "248281bc-0163-4920-a32a-148aec7034ec" || id ==="99767887-273e-47ac-baa2-1ab41cfc7043")
        json = {
            "payload": [
                {
                    "title": "ماهکس ",
                    "value": "mahex",
                    "imgLink": "https://staging.podro.com/logos/mahexLogo.png"
                }
            ],
            "message": ""
        }
    if(id === "fdf34ba5-0368-482c-bb7c-29e5601323d1")
        json = {
            "payload": [
                {
                    "title": "اکوپیک ",
                    "value": "ecopeyk",
                    "imgLink": "https://staging.podro.com/logos/ecopeykLogo.png"
                }
            ],
            "message": ""
        }

    return json

}
export const cartShipmentInfosJson = (itemsCount)=>{
    return  {
        "payload": [
            {
                "quoteDonePercentage": 100,
                "recommendations": [
                    {
                        "id": "79bd52bb-a4fe-45cc-9fa8-779349e192f4",
                        "title": "ارزانترین",
                        "totalCount": 2,
                        "totalPrice": 146255 * itemsCount,
                        "providers": [
                            {
                                "id": "post-regular",
                                "name": "شرکت ملی پست (پیشتاز) ",
                                "itemsCount": itemsCount,
                                "totalPrice": 146255*itemsCount,
                                "timeSlots": [
                                    {
                                        "id": "2022-12-26-1",
                                        "pickup": {
                                            "from": 1672032600,
                                            "to": 1672050600
                                        },
                                        "routes": [
                                            {
                                                "type": "Route",
                                                "route": "تهران-تهران",
                                                "deliveries": [
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "24 تا 48 ساعت-1",
                                                        "from": 0,
                                                        "to": 0,
                                                        "title": "24 تا 48 ساعت",
                                                        "deliveryType": "string"
                                                    }
                                                ]
                                            }
                                        ],
                                        "expired_at": 1672000200
                                    },
                                    {
                                        "id": "2022-12-28-1",
                                        "pickup": {
                                            "from": 1672205400,
                                            "to": 1672223400
                                        },
                                        "routes": [
                                            {
                                                "type": "Route",
                                                "route": "تهران-تهران",
                                                "deliveries": [
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "24 تا 48 ساعت-1",
                                                        "from": 0,
                                                        "to": 0,
                                                        "title": "24 تا 48 ساعت",
                                                        "deliveryType": "string"
                                                    }
                                                ]
                                            }
                                        ],
                                        "expired_at": 1672173000
                                    },
                                    {
                                        "id": "2022-12-31-1",
                                        "pickup": {
                                            "from": 1672464600,
                                            "to": 1672482600
                                        },
                                        "routes": [
                                            {
                                                "type": "Route",
                                                "route": "تهران-تهران",
                                                "deliveries": [
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "24 تا 48 ساعت-1",
                                                        "from": 0,
                                                        "to": 0,
                                                        "title": "24 تا 48 ساعت",
                                                        "deliveryType": "string"
                                                    }
                                                ]
                                            }
                                        ],
                                        "expired_at": 1672432200
                                    },
                                    {
                                        "id": "2023-01-01-1",
                                        "pickup": {
                                            "from": 1672551000,
                                            "to": 1672569000
                                        },
                                        "routes": [
                                            {
                                                "type": "Route",
                                                "route": "تهران-تهران",
                                                "deliveries": [
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "24 تا 48 ساعت-1",
                                                        "from": 0,
                                                        "to": 0,
                                                        "title": "24 تا 48 ساعت",
                                                        "deliveryType": "string"
                                                    }
                                                ]
                                            }
                                        ],
                                        "expired_at": 1672518600
                                    },
                                    {
                                        "id": "2023-01-02-1",
                                        "pickup": {
                                            "from": 1672637400,
                                            "to": 1672655400
                                        },
                                        "routes": [
                                            {
                                                "type": "Route",
                                                "route": "تهران-تهران",
                                                "deliveries": [
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "24 تا 48 ساعت-1",
                                                        "from": 0,
                                                        "to": 0,
                                                        "title": "24 تا 48 ساعت",
                                                        "deliveryType": "string"
                                                    }
                                                ]
                                            }
                                        ],
                                        "expired_at": 1672605000
                                    },
                                    {
                                        "id": "2023-01-03-1",
                                        "pickup": {
                                            "from": 1672723800,
                                            "to": 1672741800
                                        },
                                        "routes": [
                                            {
                                                "type": "Route",
                                                "route": "تهران-تهران",
                                                "deliveries": [
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "24 تا 48 ساعت-1",
                                                        "from": 0,
                                                        "to": 0,
                                                        "title": "24 تا 48 ساعت",
                                                        "deliveryType": "string"
                                                    }
                                                ]
                                            }
                                        ],
                                        "expired_at": 1672691400
                                    }
                                ],
                                "logo": "https://staging.podro.com/logos/postLogo.png"
                            }
                        ],
                        "paymentOptions": {
                            "sender": [
                                "credit",
                                "pasargad",
                                "pod"
                            ]
                        },
                        "paymentOptionsWithDiscount": {
                            "sender": [
                                {
                                    "method": "credit",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 146255*itemsCount,
                                    "pickupFee": 146255,
                                    "canUse": true
                                },
                                {
                                    "method": "pasargad",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 146255*itemsCount,
                                    "pickupFee": 100000,
                                    "canUse": true
                                },
                                {
                                    "method": "pod",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 146255*itemsCount,
                                    "pickupFee": 146255,
                                    "canUse": true
                                }
                            ]
                        },
                    },
                    {
                        "id": "464e4018-7e22-4d35-8490-cbad09bdd460",
                        "title": "سریع ترین",
                        "totalCount": itemsCount,
                        "totalPrice": 255000 * itemsCount,
                        "providers": [
                            {
                                "id": "link-regular",
                                "name": "لینک اکسپرس ",
                                "itemsCount": itemsCount,
                                "totalPrice": 255000 * itemsCount,
                                "timeSlots": [
                                    {
                                        "id": "2022-12-25-2",
                                        "pickup": {
                                            "from": 1671967800,
                                            "to": 1671985800
                                        },
                                        "routes": [
                                            {
                                                "type": "Route",
                                                "route": "تهران-تهران",
                                                "deliveries": [
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-26-1",
                                                        "from": 1672032600,
                                                        "to": 1672050600,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-26-2",
                                                        "from": 1672054200,
                                                        "to": 1672072200,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-28-1",
                                                        "from": 1672205400,
                                                        "to": 1672223400,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-28-2",
                                                        "from": 1672227000,
                                                        "to": 1672245000,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-29-1",
                                                        "from": 1672291800,
                                                        "to": 1672309800,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-29-2",
                                                        "from": 1672313400,
                                                        "to": 1672331400,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    }
                                                ]
                                            }
                                        ],
                                        "expired_at": 1671967800
                                    },
                                    {
                                        "id": "2022-12-26-1",
                                        "pickup": {
                                            "from": 1672032600,
                                            "to": 1672047000
                                        },
                                        "routes": [
                                            {
                                                "type": "Route",
                                                "route": "تهران-تهران",
                                                "deliveries": [
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-26-2",
                                                        "from": 1672054200,
                                                        "to": 1672072200,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-28-1",
                                                        "from": 1672205400,
                                                        "to": 1672223400,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-28-2",
                                                        "from": 1672227000,
                                                        "to": 1672245000,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-29-1",
                                                        "from": 1672291800,
                                                        "to": 1672309800,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-29-2",
                                                        "from": 1672313400,
                                                        "to": 1672331400,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-31-1",
                                                        "from": 1672464600,
                                                        "to": 1672482600,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    }
                                                ]
                                            }
                                        ],
                                        "expired_at": 1672032600
                                    },
                                    {
                                        "id": "2022-12-26-2",
                                        "pickup": {
                                            "from": 1672054200,
                                            "to": 1672072200
                                        },
                                        "routes": [
                                            {
                                                "type": "Route",
                                                "route": "تهران-تهران",
                                                "deliveries": [
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-28-1",
                                                        "from": 1672205400,
                                                        "to": 1672223400,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-28-2",
                                                        "from": 1672227000,
                                                        "to": 1672245000,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-29-1",
                                                        "from": 1672291800,
                                                        "to": 1672309800,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-29-2",
                                                        "from": 1672313400,
                                                        "to": 1672331400,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-31-1",
                                                        "from": 1672464600,
                                                        "to": 1672482600,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-31-2",
                                                        "from": 1672486200,
                                                        "to": 1672504200,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    }
                                                ]
                                            }
                                        ],
                                        "expired_at": 1672054200
                                    },
                                    {
                                        "id": "2022-12-28-1",
                                        "pickup": {
                                            "from": 1672205400,
                                            "to": 1672219800
                                        },
                                        "routes": [
                                            {
                                                "type": "Route",
                                                "route": "تهران-تهران",
                                                "deliveries": [
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-28-2",
                                                        "from": 1672227000,
                                                        "to": 1672245000,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-29-1",
                                                        "from": 1672291800,
                                                        "to": 1672309800,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-29-2",
                                                        "from": 1672313400,
                                                        "to": 1672331400,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-31-1",
                                                        "from": 1672464600,
                                                        "to": 1672482600,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-31-2",
                                                        "from": 1672486200,
                                                        "to": 1672504200,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2023-01-01-1",
                                                        "from": 1672551000,
                                                        "to": 1672569000,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    }
                                                ]
                                            }
                                        ],
                                        "expired_at": 1672205400
                                    },
                                    {
                                        "id": "2022-12-28-2",
                                        "pickup": {
                                            "from": 1672227000,
                                            "to": 1672245000
                                        },
                                        "routes": [
                                            {
                                                "type": "Route",
                                                "route": "تهران-تهران",
                                                "deliveries": [
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-29-1",
                                                        "from": 1672291800,
                                                        "to": 1672309800,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-29-2",
                                                        "from": 1672313400,
                                                        "to": 1672331400,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-31-1",
                                                        "from": 1672464600,
                                                        "to": 1672482600,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-31-2",
                                                        "from": 1672486200,
                                                        "to": 1672504200,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2023-01-01-1",
                                                        "from": 1672551000,
                                                        "to": 1672569000,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2023-01-01-2",
                                                        "from": 1672572600,
                                                        "to": 1672590600,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    }
                                                ]
                                            }
                                        ],
                                        "expired_at": 1672227000
                                    },
                                    {
                                        "id": "2022-12-29-1",
                                        "pickup": {
                                            "from": 1672291800,
                                            "to": 1672306200
                                        },
                                        "routes": [
                                            {
                                                "type": "Route",
                                                "route": "تهران-تهران",
                                                "deliveries": [
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-29-2",
                                                        "from": 1672313400,
                                                        "to": 1672331400,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-31-1",
                                                        "from": 1672464600,
                                                        "to": 1672482600,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2022-12-31-2",
                                                        "from": 1672486200,
                                                        "to": 1672504200,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2023-01-01-1",
                                                        "from": 1672551000,
                                                        "to": 1672569000,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2023-01-01-2",
                                                        "from": 1672572600,
                                                        "to": 1672590600,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    },
                                                    {
                                                        "type": "Delivery",
                                                        "reference": "2023-01-02-1",
                                                        "from": 1672637400,
                                                        "to": 1672655400,
                                                        "title": null,
                                                        "deliveryType": "dateTime"
                                                    }
                                                ]
                                            }
                                        ],
                                        "expired_at": 1672291800
                                    }
                                ],
                                "logo": "https://staging.podro.com/logos/linkLogo.png"
                            }
                        ],
                        "paymentOptions": {
                            "sender": [
                                "credit",
                                "pasargad",
                                "pod"
                            ]
                        },
                        "paymentOptionsWithDiscount": {
                            "sender": [
                                {
                                    "method": "credit",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 255000*itemsCount,
                                    "pickupFee": 255000,
                                    "canUse": true
                                },
                                {
                                    "method": "pasargad",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 255000*itemsCount,
                                    "pickupFee": 255000,
                                    "canUse": true
                                },
                                {
                                    "method": "pod",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 255000*itemsCount,
                                    "pickupFee": 146255,
                                    "canUse": true
                                }
                            ]
                        },
                    }
                ],
                "shipments": [
                    {
                        "id": "0d8e0891-e187-4b64-86f8-6a9b29577e4a",
                        "provider": {
                            "id": "link-regular",
                            "name": "لینک اکسپرس ",
                            "itemsCount": itemsCount,
                            "totalPrice": 255000 * itemsCount,
                            "timeSlots": [
                                {
                                    "id": "2022-12-25-2",
                                    "pickup": {
                                        "from": 1671967800,
                                        "to": 1671985800
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-26-1",
                                                    "from": 1672032600,
                                                    "to": 1672050600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-26-2",
                                                    "from": 1672054200,
                                                    "to": 1672072200,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-1",
                                                    "from": 1672205400,
                                                    "to": 1672223400,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-2",
                                                    "from": 1672227000,
                                                    "to": 1672245000,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-1",
                                                    "from": 1672291800,
                                                    "to": 1672309800,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-2",
                                                    "from": 1672313400,
                                                    "to": 1672331400,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1671967800
                                },
                                {
                                    "id": "2022-12-26-1",
                                    "pickup": {
                                        "from": 1672032600,
                                        "to": 1672047000
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-26-2",
                                                    "from": 1672054200,
                                                    "to": 1672072200,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-1",
                                                    "from": 1672205400,
                                                    "to": 1672223400,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-2",
                                                    "from": 1672227000,
                                                    "to": 1672245000,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-1",
                                                    "from": 1672291800,
                                                    "to": 1672309800,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-2",
                                                    "from": 1672313400,
                                                    "to": 1672331400,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-31-1",
                                                    "from": 1672464600,
                                                    "to": 1672482600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672032600
                                },
                                {
                                    "id": "2022-12-26-2",
                                    "pickup": {
                                        "from": 1672054200,
                                        "to": 1672072200
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-1",
                                                    "from": 1672205400,
                                                    "to": 1672223400,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-2",
                                                    "from": 1672227000,
                                                    "to": 1672245000,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-1",
                                                    "from": 1672291800,
                                                    "to": 1672309800,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-2",
                                                    "from": 1672313400,
                                                    "to": 1672331400,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-31-1",
                                                    "from": 1672464600,
                                                    "to": 1672482600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-31-2",
                                                    "from": 1672486200,
                                                    "to": 1672504200,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672054200
                                },
                                {
                                    "id": "2022-12-28-1",
                                    "pickup": {
                                        "from": 1672205400,
                                        "to": 1672219800
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-2",
                                                    "from": 1672227000,
                                                    "to": 1672245000,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-1",
                                                    "from": 1672291800,
                                                    "to": 1672309800,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-2",
                                                    "from": 1672313400,
                                                    "to": 1672331400,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-31-1",
                                                    "from": 1672464600,
                                                    "to": 1672482600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-31-2",
                                                    "from": 1672486200,
                                                    "to": 1672504200,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2023-01-01-1",
                                                    "from": 1672551000,
                                                    "to": 1672569000,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672205400
                                },
                                {
                                    "id": "2022-12-28-2",
                                    "pickup": {
                                        "from": 1672227000,
                                        "to": 1672245000
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-1",
                                                    "from": 1672291800,
                                                    "to": 1672309800,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-2",
                                                    "from": 1672313400,
                                                    "to": 1672331400,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-31-1",
                                                    "from": 1672464600,
                                                    "to": 1672482600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-31-2",
                                                    "from": 1672486200,
                                                    "to": 1672504200,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2023-01-01-1",
                                                    "from": 1672551000,
                                                    "to": 1672569000,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2023-01-01-2",
                                                    "from": 1672572600,
                                                    "to": 1672590600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672227000
                                },
                                {
                                    "id": "2022-12-29-1",
                                    "pickup": {
                                        "from": 1672291800,
                                        "to": 1672306200
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-2",
                                                    "from": 1672313400,
                                                    "to": 1672331400,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-31-1",
                                                    "from": 1672464600,
                                                    "to": 1672482600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-31-2",
                                                    "from": 1672486200,
                                                    "to": 1672504200,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2023-01-01-1",
                                                    "from": 1672551000,
                                                    "to": 1672569000,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2023-01-01-2",
                                                    "from": 1672572600,
                                                    "to": 1672590600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2023-01-02-1",
                                                    "from": 1672637400,
                                                    "to": 1672655400,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672291800
                                }
                            ],
                            "logo": "https://staging.podro.com/logos/linkLogo.png"
                        },
                        "unhandledItemsAlternative": {
                            "id": "33bd720e-bbc9-4e5a-8650-cc4616168fe8",
                            "title": "ارزانترین",
                            "totalCount": 0,
                            "totalPrice": 0,
                            "providers": [],
                            "paymentOptions": [],
                            "paymentOptionsWithDiscount": []
                        },
                        "paymentOptions": {
                            "sender": [
                                "credit",
                                "pasargad",
                                "pod"
                            ]
                        },
                        "paymentOptionsWithDiscount": {
                            "sender": [
                                {
                                    "method": "credit",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 146255*itemsCount,
                                    "pickupFee": 146255,
                                    "canUse": true
                                },
                                {
                                    "method": "pasargad",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 146255*itemsCount,
                                    "pickupFee": 100000,
                                    "canUse": true
                                },
                                {
                                    "method": "pod",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 146255*itemsCount,
                                    "pickupFee": 146255,
                                    "canUse": true
                                }
                            ]
                        },
                        "alternativePaymentOptions": [],
                        "alternativePaymentOptionsWithDiscount": []
                    },
                    {
                        "id": "131dcf4f-4d3d-486b-b9d1-69336bda8c8c",
                        "provider": {
                            "id": "podex-regular",
                            "name": "پادرو اکسپرس ",
                            "itemsCount": itemsCount,
                            "totalPrice": 300000 * itemsCount,
                            "timeSlots": [
                                {
                                    "id": "2022-12-26-1",
                                    "pickup": {
                                        "from": 1672029000,
                                        "to": 1672032600
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "تا پنج ساعت بعد از جمع‌آوری-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "تا پنج ساعت بعد از جمع‌آوری",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1671975000
                                },
                                {
                                    "id": "2022-12-26-2",
                                    "pickup": {
                                        "from": 1672047000,
                                        "to": 1672050600
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "تا پنج ساعت بعد از جمع‌آوری-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "تا پنج ساعت بعد از جمع‌آوری",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672043400
                                },
                                {
                                    "id": "2022-12-28-1",
                                    "pickup": {
                                        "from": 1672201800,
                                        "to": 1672205400
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "تا پنج ساعت بعد از جمع‌آوری-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "تا پنج ساعت بعد از جمع‌آوری",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672147800
                                },
                                {
                                    "id": "2022-12-28-2",
                                    "pickup": {
                                        "from": 1672219800,
                                        "to": 1672223400
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "تا پنج ساعت بعد از جمع‌آوری-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "تا پنج ساعت بعد از جمع‌آوری",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672216200
                                },
                                {
                                    "id": "2022-12-29-1",
                                    "pickup": {
                                        "from": 1672288200,
                                        "to": 1672291800
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "تا پنج ساعت بعد از جمع‌آوری-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "تا پنج ساعت بعد از جمع‌آوری",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672234200
                                },
                                {
                                    "id": "2022-12-31-1",
                                    "pickup": {
                                        "from": 1672461000,
                                        "to": 1672464600
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "تا پنج ساعت بعد از جمع‌آوری-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "تا پنج ساعت بعد از جمع‌آوری",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672407000
                                }
                            ],
                            "logo": "https://staging.podro.com/logos/podroExpress.png"
                        },
                        "unhandledItemsAlternative": {
                            "id": "e2bf6a18-9506-4773-a6c1-27b3eab4d565",
                            "title": "ارزانترین",
                            "totalCount": 0,
                            "totalPrice": 0,
                            "providers": [],
                            "paymentOptions": [],
                            "paymentOptionsWithDiscount": []
                        },
                        "paymentOptions": {
                            "sender": [
                                "cash"
                            ]
                        },
                        "paymentOptionsWithDiscount": {
                            "sender": [
                                {
                                    "method": "cash",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 660000,
                                    "pickupFee": 60000,
                                    "canUse": true
                                }
                            ]
                        },
                        "alternativePaymentOptions": [],
                        "alternativePaymentOptionsWithDiscount": []
                    },
                    {
                        "id": "16e7c4bb-bb77-44cc-a414-1c5fe5eab3d5",
                        "provider": {
                            "id": "speed-regular",
                            "name": "اسپید ",
                            "itemsCount": itemsCount,
                            "totalPrice": 240000 * itemsCount,
                            "timeSlots": [
                                {
                                    "id": "2022-12-25-2",
                                    "pickup": {
                                        "from": 1671967800,
                                        "to": 1671975000
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-26-1",
                                                    "from": 1672032600,
                                                    "to": 1672054200,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-26-2",
                                                    "from": 1672054200,
                                                    "to": 1672075800,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-1",
                                                    "from": 1672205400,
                                                    "to": 1672227000,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-2",
                                                    "from": 1672227000,
                                                    "to": 1672248600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-1",
                                                    "from": 1672291800,
                                                    "to": 1672313400,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-2",
                                                    "from": 1672313400,
                                                    "to": 1672335000,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1671964200
                                },
                                {
                                    "id": "2022-12-26-1",
                                    "pickup": {
                                        "from": 1672036200,
                                        "to": 1672043400
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-26-2",
                                                    "from": 1672054200,
                                                    "to": 1672075800,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-1",
                                                    "from": 1672205400,
                                                    "to": 1672227000,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-2",
                                                    "from": 1672227000,
                                                    "to": 1672248600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-1",
                                                    "from": 1672291800,
                                                    "to": 1672313400,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-2",
                                                    "from": 1672313400,
                                                    "to": 1672335000,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-31-1",
                                                    "from": 1672464600,
                                                    "to": 1672486200,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672032600
                                },
                                {
                                    "id": "2022-12-26-2",
                                    "pickup": {
                                        "from": 1672054200,
                                        "to": 1672061400
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-1",
                                                    "from": 1672205400,
                                                    "to": 1672227000,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-2",
                                                    "from": 1672227000,
                                                    "to": 1672248600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-1",
                                                    "from": 1672291800,
                                                    "to": 1672313400,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-2",
                                                    "from": 1672313400,
                                                    "to": 1672335000,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-31-1",
                                                    "from": 1672464600,
                                                    "to": 1672486200,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-31-2",
                                                    "from": 1672486200,
                                                    "to": 1672507800,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672050600
                                },
                                {
                                    "id": "2022-12-28-1",
                                    "pickup": {
                                        "from": 1672209000,
                                        "to": 1672216200
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-2",
                                                    "from": 1672227000,
                                                    "to": 1672248600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-1",
                                                    "from": 1672291800,
                                                    "to": 1672313400,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-2",
                                                    "from": 1672313400,
                                                    "to": 1672335000,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-31-1",
                                                    "from": 1672464600,
                                                    "to": 1672486200,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-31-2",
                                                    "from": 1672486200,
                                                    "to": 1672507800,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2023-01-01-1",
                                                    "from": 1672551000,
                                                    "to": 1672572600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672205400
                                },
                                {
                                    "id": "2022-12-28-2",
                                    "pickup": {
                                        "from": 1672227000,
                                        "to": 1672234200
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-1",
                                                    "from": 1672291800,
                                                    "to": 1672313400,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-2",
                                                    "from": 1672313400,
                                                    "to": 1672335000,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-31-1",
                                                    "from": 1672464600,
                                                    "to": 1672486200,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-31-2",
                                                    "from": 1672486200,
                                                    "to": 1672507800,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2023-01-01-1",
                                                    "from": 1672551000,
                                                    "to": 1672572600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2023-01-01-2",
                                                    "from": 1672572600,
                                                    "to": 1672594200,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672223400
                                },
                                {
                                    "id": "2022-12-29-1",
                                    "pickup": {
                                        "from": 1672295400,
                                        "to": 1672302600
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-2",
                                                    "from": 1672313400,
                                                    "to": 1672335000,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-31-1",
                                                    "from": 1672464600,
                                                    "to": 1672486200,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-31-2",
                                                    "from": 1672486200,
                                                    "to": 1672507800,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2023-01-01-1",
                                                    "from": 1672551000,
                                                    "to": 1672572600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2023-01-01-2",
                                                    "from": 1672572600,
                                                    "to": 1672594200,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2023-01-02-1",
                                                    "from": 1672637400,
                                                    "to": 1672659000,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672291800
                                }
                            ],
                            "logo": "https://staging.podro.com/logos/speedLogo.png"
                        },
                        "unhandledItemsAlternative": {
                            "id": "8144138c-7658-4981-8c5a-1c0d2c3cd99f",
                            "title": "ارزانترین",
                            "totalCount": 0,
                            "totalPrice": 0,
                            "providers": [],
                            "paymentOptions": [],
                            "paymentOptionsWithDiscount": []
                        },
                        "paymentOptions": {
                            "sender": [
                                "cash"
                            ],
                            "receiver": [
                                "cash"
                            ]
                        },
                        "paymentOptionsWithDiscount": {
                            "sender": [
                                {
                                    "method": "cash",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 540000,
                                    "pickupFee": 60000,
                                    "canUse": true
                                }
                            ],
                            "receiver": [
                                {
                                    "method": "cash",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 540000,
                                    "pickupFee": 60000,
                                    "canUse": true
                                }
                            ]
                        },
                        "alternativePaymentOptions": [],
                        "alternativePaymentOptionsWithDiscount": []
                    },
                    {
                        "id": "527e5122-f085-47a6-b20f-560fd506ddc1",
                        "provider": {
                            "id": "post-regular",
                            "name": "شرکت ملی پست (پیشتاز) ",
                            "itemsCount": itemsCount,
                            "totalPrice": 146255 * itemsCount,
                            "timeSlots": [
                                {
                                    "id": "2022-12-26-1",
                                    "pickup": {
                                        "from": 1672032600,
                                        "to": 1672050600
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 48 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 48 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672000200
                                },
                                {
                                    "id": "2022-12-28-1",
                                    "pickup": {
                                        "from": 1672205400,
                                        "to": 1672223400
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 48 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 48 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672173000
                                },
                                {
                                    "id": "2022-12-31-1",
                                    "pickup": {
                                        "from": 1672464600,
                                        "to": 1672482600
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 48 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 48 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672432200
                                },
                                {
                                    "id": "2023-01-01-1",
                                    "pickup": {
                                        "from": 1672551000,
                                        "to": 1672569000
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 48 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 48 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672518600
                                },
                                {
                                    "id": "2023-01-02-1",
                                    "pickup": {
                                        "from": 1672637400,
                                        "to": 1672655400
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 48 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 48 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672605000
                                },
                                {
                                    "id": "2023-01-03-1",
                                    "pickup": {
                                        "from": 1672723800,
                                        "to": 1672741800
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 48 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 48 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672691400
                                }
                            ],
                            "logo": "https://staging.podro.com/logos/postLogo.png"
                        },
                        "unhandledItemsAlternative": {
                            "id": "451b4e33-ef05-4504-aa22-be19aec01202",
                            "title": "ارزانترین",
                            "totalCount": 0,
                            "totalPrice": 0,
                            "providers": [],
                            "paymentOptions": [],
                            "paymentOptionsWithDiscount": []
                        },
                        "paymentOptions": {
                            "sender": [
                                "credit",
                                "pasargad",
                                "pod"
                            ]
                        },
                        "paymentOptionsWithDiscount": {
                            "sender": [
                                {
                                    "method": "credit",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 146255*itemsCount,
                                    "pickupFee": 146255,
                                    "canUse": true
                                },
                                {
                                    "method": "pasargad",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 146255*itemsCount,
                                    "pickupFee": 100000,
                                    "canUse": true
                                },
                                {
                                    "method": "pod",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 146255*itemsCount,
                                    "pickupFee": 146255,
                                    "canUse": true
                                }
                            ]
                        },
                        "alternativePaymentOptions": [],
                        "alternativePaymentOptionsWithDiscount": []
                    },
                    {
                        "id": "8e01171b-5727-474f-8291-e319a472aaa8",
                        "provider": {
                            "id": "pishropost-regular",
                            "name": "پیشروپست ",
                            "itemsCount": itemsCount,
                            "totalPrice": 245000 * itemsCount,
                            "timeSlots": [
                                {
                                    "id": "2022-12-26-1",
                                    "pickup": {
                                        "from": 1672032600,
                                        "to": 1672050600
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 72 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 72 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672000200
                                },
                                {
                                    "id": "2022-12-26-2",
                                    "pickup": {
                                        "from": 1672050600,
                                        "to": 1672068600
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 72 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 72 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672036200
                                },
                                {
                                    "id": "2022-12-28-1",
                                    "pickup": {
                                        "from": 1672205400,
                                        "to": 1672223400
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 72 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 72 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672173000
                                },
                                {
                                    "id": "2022-12-28-2",
                                    "pickup": {
                                        "from": 1672223400,
                                        "to": 1672241400
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 72 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 72 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672209000
                                },
                                {
                                    "id": "2022-12-29-1",
                                    "pickup": {
                                        "from": 1672291800,
                                        "to": 1672309800
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 72 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 72 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672259400
                                },
                                {
                                    "id": "2022-12-29-2",
                                    "pickup": {
                                        "from": 1672309800,
                                        "to": 1672327800
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 72 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 72 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672295400
                                }
                            ],
                            "logo": "https://staging.podro.com/logos/pishropostLogo.png"
                        },
                        "unhandledItemsAlternative": {
                            "id": "b26964b0-1a8a-4092-b1d1-c73a4af59223",
                            "title": "ارزانترین",
                            "totalCount": 0,
                            "totalPrice": 0,
                            "providers": [],
                            "paymentOptions": [],
                            "paymentOptionsWithDiscount": []
                        },
                        "paymentOptions": {
                            "sender": [
                                "cash",
                                "pasargad",
                                "pod"
                            ]
                        },
                        "paymentOptionsWithDiscount": {
                            "sender": [
                                {
                                    "method": "cash",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 550000,
                                    "pickupFee": 60000,
                                    "canUse": true
                                },
                                {
                                    "method": "pasargad",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 550000,
                                    "pickupFee": 60000,
                                    "canUse": true
                                },
                                {
                                    "method": "pod",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 550000,
                                    "pickupFee": 60000,
                                    "canUse": true
                                }
                            ]
                        },
                        "alternativePaymentOptions": [],
                        "alternativePaymentOptionsWithDiscount": []
                    },
                    {
                        "id": "81b84e42-b229-4f2f-ad8f-f1d09e3e13ee",
                        "provider": {
                            "id": "nedex-regular",
                            "name": "ندکس ",
                            "itemsCount": itemsCount,
                            "totalPrice": 260001 * itemsCount,
                            "timeSlots": [
                                {
                                    "id": "2022-12-26-1",
                                    "pickup": {
                                        "from": 1672032600,
                                        "to": 1672050600
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 192 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 192 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672029000
                                },
                                {
                                    "id": "2022-12-26-2",
                                    "pickup": {
                                        "from": 1672050600,
                                        "to": 1672068600
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 192 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 192 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672047000
                                },
                                {
                                    "id": "2022-12-28-1",
                                    "pickup": {
                                        "from": 1672205400,
                                        "to": 1672223400
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 192 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 192 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672201800
                                },
                                {
                                    "id": "2022-12-28-2",
                                    "pickup": {
                                        "from": 1672223400,
                                        "to": 1672241400
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 192 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 192 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672219800
                                },
                                {
                                    "id": "2022-12-29-1",
                                    "pickup": {
                                        "from": 1672291800,
                                        "to": 1672309800
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 192 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 192 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672288200
                                },
                                {
                                    "id": "2022-12-31-1",
                                    "pickup": {
                                        "from": 1672464600,
                                        "to": 1672482600
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 192 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 192 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672461000
                                }
                            ],
                            "logo": "https://staging.podro.com/logos/nedexLogo.png"
                        },
                        "unhandledItemsAlternative": {
                            "id": "cd151b13-3894-4ef8-93bc-943bb9d984dd",
                            "title": "ارزانترین",
                            "totalCount": 0,
                            "totalPrice": 0,
                            "providers": [],
                            "paymentOptions": [],
                            "paymentOptionsWithDiscount": []
                        },
                        "paymentOptions": {
                            "sender": [
                                "cash"
                            ],
                            "receiver": [
                                "cash"
                            ]
                        },
                        "paymentOptionsWithDiscount": {
                            "sender": [
                                {
                                    "method": "cash",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 520002,
                                    "pickupFee": 0,
                                    "canUse": true
                                }
                            ],
                            "receiver": [
                                {
                                    "method": "cash",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 520002,
                                    "pickupFee": 0,
                                    "canUse": true
                                }
                            ]
                        },
                        "alternativePaymentOptions": [],
                        "alternativePaymentOptionsWithDiscount": []
                    },
                    {
                        "id": "5f2972f5-21d9-4ed2-b706-abf584e11d06",
                        "provider": {
                            "id": "chapar-regular",
                            "name": "چاپار ",
                            "itemsCount": itemsCount,
                            "totalPrice": 223600*itemsCount,
                            "timeSlots": [
                                {
                                    "id": "2022-12-26-1",
                                    "pickup": {
                                        "from": 1672032600,
                                        "to": 1672061400
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 72 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 72 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1671993000
                                },
                                {
                                    "id": "2022-12-28-1",
                                    "pickup": {
                                        "from": 1672205400,
                                        "to": 1672234200
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 72 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 72 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672165800
                                },
                                {
                                    "id": "2022-12-29-1",
                                    "pickup": {
                                        "from": 1672291800,
                                        "to": 1672320600
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 72 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 72 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672252200
                                },
                                {
                                    "id": "2022-12-31-1",
                                    "pickup": {
                                        "from": 1672464600,
                                        "to": 1672493400
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 72 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 72 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672425000
                                },
                                {
                                    "id": "2023-01-01-1",
                                    "pickup": {
                                        "from": 1672551000,
                                        "to": 1672579800
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 72 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 72 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672511400
                                },
                                {
                                    "id": "2023-01-02-1",
                                    "pickup": {
                                        "from": 1672637400,
                                        "to": 1672666200
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 72 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 72 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672597800
                                }
                            ],
                            "logo": "https://staging.podro.com/logos/chaparLogo.png"
                        },
                        "unhandledItemsAlternative": {
                            "id": "be48e1ec-9f5e-47ee-a4ff-d7fb448d60fa",
                            "title": "ارزانترین",
                            "totalCount": 0,
                            "totalPrice": 0,
                            "providers": [],
                            "paymentOptions": [],
                            "paymentOptionsWithDiscount": []
                        },
                        "paymentOptions": {
                            "sender": [
                                "cash"
                            ],
                            "receiver": [
                                "cash"
                            ]
                        },
                        "paymentOptionsWithDiscount": {
                            "sender": [
                                {
                                    "method": "cash",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 507200,
                                    "pickupFee": 60000,
                                    "canUse": true
                                }
                            ],
                            "receiver": [
                                {
                                    "method": "cash",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 507200,
                                    "pickupFee": 60000,
                                    "canUse": true
                                }
                            ]
                        },
                        "alternativePaymentOptions": [],
                        "alternativePaymentOptionsWithDiscount": []
                    },
                    {
                        "id": "99767887-273e-47ac-baa2-1ab41cfc7043",
                        "provider": {
                            "id": "mahex-regular",
                            "name": "ماهکس ",
                            "itemsCount": itemsCount,
                            "totalPrice": 429000 * itemsCount,
                            "timeSlots": [
                                {
                                    "id": "2022-12-26-1",
                                    "pickup": {
                                        "from": 1672032600,
                                        "to": 1672047000
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 72 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 72 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1671982200
                                },
                                {
                                    "id": "2022-12-26-2",
                                    "pickup": {
                                        "from": 1672047000,
                                        "to": 1672061400
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 72 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 72 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672036200
                                },
                                {
                                    "id": "2022-12-28-1",
                                    "pickup": {
                                        "from": 1672205400,
                                        "to": 1672219800
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 72 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 72 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672155000
                                },
                                {
                                    "id": "2022-12-28-2",
                                    "pickup": {
                                        "from": 1672219800,
                                        "to": 1672234200
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 72 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 72 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672209000
                                },
                                {
                                    "id": "2022-12-29-1",
                                    "pickup": {
                                        "from": 1672291800,
                                        "to": 1672306200
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 72 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 72 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672241400
                                },
                                {
                                    "id": "2022-12-31-1",
                                    "pickup": {
                                        "from": 1672464600,
                                        "to": 1672479000
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "24 تا 72 ساعت-1",
                                                    "from": 0,
                                                    "to": 0,
                                                    "title": "24 تا 72 ساعت",
                                                    "deliveryType": "string"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672414200
                                }
                            ],
                            "logo": "https://staging.podro.com/logos/mahexLogo.png"
                        },
                        "unhandledItemsAlternative": {
                            "id": "7e2aa19c-17c2-48ce-a38a-c8d5f1f946d6",
                            "title": "ارزانترین",
                            "totalCount": 0,
                            "totalPrice": 0,
                            "providers": [],
                            "paymentOptions": [],
                            "paymentOptionsWithDiscount": []
                        },
                        "paymentOptions": {
                            "sender": [
                                "cash"
                            ]
                        },
                        "paymentOptionsWithDiscount": {
                            "sender": [
                                {
                                    "method": "cash",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 918000,
                                    "pickupFee": 60000,
                                    "canUse": true
                                }
                            ]
                        },
                        "alternativePaymentOptions": [],
                        "alternativePaymentOptionsWithDiscount": []
                    },
                    {
                        "id": "fdf34ba5-0368-482c-bb7c-29e5601323d1",
                        "provider": {
                            "id": "ecopeyk-regular",
                            "name": "اکوپیک ",
                            "itemsCount": itemsCount,
                            "totalPrice": 124500 * itemsCount,
                            "timeSlots": [
                                {
                                    "id": "2022-12-25-3",
                                    "pickup": {
                                        "from": 1671978600,
                                        "to": 1671989400
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-26-1",
                                                    "from": 1672032600,
                                                    "to": 1672043400,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-26-2",
                                                    "from": 1672050600,
                                                    "to": 1672061400,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-26-3",
                                                    "from": 1672065000,
                                                    "to": 1672075800,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-1",
                                                    "from": 1672205400,
                                                    "to": 1672216200,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-2",
                                                    "from": 1672223400,
                                                    "to": 1672234200,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-3",
                                                    "from": 1672237800,
                                                    "to": 1672248600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1671971400
                                },
                                {
                                    "id": "2022-12-26-1",
                                    "pickup": {
                                        "from": 1672032600,
                                        "to": 1672043400
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-26-2",
                                                    "from": 1672050600,
                                                    "to": 1672061400,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-26-3",
                                                    "from": 1672065000,
                                                    "to": 1672075800,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-1",
                                                    "from": 1672205400,
                                                    "to": 1672216200,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-2",
                                                    "from": 1672223400,
                                                    "to": 1672234200,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-3",
                                                    "from": 1672237800,
                                                    "to": 1672248600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-1",
                                                    "from": 1672291800,
                                                    "to": 1672302600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672025400
                                },
                                {
                                    "id": "2022-12-26-2",
                                    "pickup": {
                                        "from": 1672050600,
                                        "to": 1672061400
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-26-3",
                                                    "from": 1672065000,
                                                    "to": 1672075800,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-1",
                                                    "from": 1672205400,
                                                    "to": 1672216200,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-2",
                                                    "from": 1672223400,
                                                    "to": 1672234200,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-3",
                                                    "from": 1672237800,
                                                    "to": 1672248600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-1",
                                                    "from": 1672291800,
                                                    "to": 1672302600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-2",
                                                    "from": 1672309800,
                                                    "to": 1672320600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672043400
                                },
                                {
                                    "id": "2022-12-26-3",
                                    "pickup": {
                                        "from": 1672065000,
                                        "to": 1672075800
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-1",
                                                    "from": 1672205400,
                                                    "to": 1672216200,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-2",
                                                    "from": 1672223400,
                                                    "to": 1672234200,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-3",
                                                    "from": 1672237800,
                                                    "to": 1672248600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-1",
                                                    "from": 1672291800,
                                                    "to": 1672302600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-2",
                                                    "from": 1672309800,
                                                    "to": 1672320600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-3",
                                                    "from": 1672324200,
                                                    "to": 1672335000,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672057800
                                },
                                {
                                    "id": "2022-12-28-1",
                                    "pickup": {
                                        "from": 1672205400,
                                        "to": 1672216200
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-2",
                                                    "from": 1672223400,
                                                    "to": 1672234200,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-3",
                                                    "from": 1672237800,
                                                    "to": 1672248600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-1",
                                                    "from": 1672291800,
                                                    "to": 1672302600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-2",
                                                    "from": 1672309800,
                                                    "to": 1672320600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-3",
                                                    "from": 1672324200,
                                                    "to": 1672335000,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-31-1",
                                                    "from": 1672464600,
                                                    "to": 1672475400,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672198200
                                },
                                {
                                    "id": "2022-12-28-2",
                                    "pickup": {
                                        "from": 1672223400,
                                        "to": 1672234200
                                    },
                                    "routes": [
                                        {
                                            "type": "Route",
                                            "route": "تهران-تهران",
                                            "deliveries": [
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-28-3",
                                                    "from": 1672237800,
                                                    "to": 1672248600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-1",
                                                    "from": 1672291800,
                                                    "to": 1672302600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-2",
                                                    "from": 1672309800,
                                                    "to": 1672320600,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-29-3",
                                                    "from": 1672324200,
                                                    "to": 1672335000,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-31-1",
                                                    "from": 1672464600,
                                                    "to": 1672475400,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                },
                                                {
                                                    "type": "Delivery",
                                                    "reference": "2022-12-31-2",
                                                    "from": 1672482600,
                                                    "to": 1672493400,
                                                    "title": null,
                                                    "deliveryType": "dateTime"
                                                }
                                            ]
                                        }
                                    ],
                                    "expired_at": 1672216200
                                }
                            ],
                            "logo": "https://staging.podro.com/logos/ecopeykLogo.png"
                        },
                        "unhandledItemsAlternative": {
                            "id": "36e167ea-e49e-4592-a7b6-b7f978d1bfe7",
                            "title": "ارزانترین",
                            "totalCount": itemsCount,
                            "totalPrice": 73127.5 * itemsCount,
                            "providers": [
                                {
                                    "id": "post-regular",
                                    "name": "شرکت ملی پست (پیشتاز) ",
                                    "itemsCount": itemsCount,
                                    "totalPrice": 73127.5,
                                    "timeSlots": [
                                        {
                                            "id": "2022-12-26-1",
                                            "pickup": {
                                                "from": 1672032600,
                                                "to": 1672050600
                                            },
                                            "routes": [
                                                {
                                                    "type": "Route",
                                                    "route": "تهران-تهران",
                                                    "deliveries": [
                                                        {
                                                            "type": "Delivery",
                                                            "reference": "24 تا 48 ساعت-1",
                                                            "from": 0,
                                                            "to": 0,
                                                            "title": "24 تا 48 ساعت",
                                                            "deliveryType": "string"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "expired_at": 1672000200
                                        },
                                        {
                                            "id": "2022-12-28-1",
                                            "pickup": {
                                                "from": 1672205400,
                                                "to": 1672223400
                                            },
                                            "routes": [
                                                {
                                                    "type": "Route",
                                                    "route": "تهران-تهران",
                                                    "deliveries": [
                                                        {
                                                            "type": "Delivery",
                                                            "reference": "24 تا 48 ساعت-1",
                                                            "from": 0,
                                                            "to": 0,
                                                            "title": "24 تا 48 ساعت",
                                                            "deliveryType": "string"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "expired_at": 1672173000
                                        },
                                        {
                                            "id": "2022-12-31-1",
                                            "pickup": {
                                                "from": 1672464600,
                                                "to": 1672482600
                                            },
                                            "routes": [
                                                {
                                                    "type": "Route",
                                                    "route": "تهران-تهران",
                                                    "deliveries": [
                                                        {
                                                            "type": "Delivery",
                                                            "reference": "24 تا 48 ساعت-1",
                                                            "from": 0,
                                                            "to": 0,
                                                            "title": "24 تا 48 ساعت",
                                                            "deliveryType": "string"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "expired_at": 1672432200
                                        },
                                        {
                                            "id": "2023-01-01-1",
                                            "pickup": {
                                                "from": 1672551000,
                                                "to": 1672569000
                                            },
                                            "routes": [
                                                {
                                                    "type": "Route",
                                                    "route": "تهران-تهران",
                                                    "deliveries": [
                                                        {
                                                            "type": "Delivery",
                                                            "reference": "24 تا 48 ساعت-1",
                                                            "from": 0,
                                                            "to": 0,
                                                            "title": "24 تا 48 ساعت",
                                                            "deliveryType": "string"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "expired_at": 1672518600
                                        },
                                        {
                                            "id": "2023-01-02-1",
                                            "pickup": {
                                                "from": 1672637400,
                                                "to": 1672655400
                                            },
                                            "routes": [
                                                {
                                                    "type": "Route",
                                                    "route": "تهران-تهران",
                                                    "deliveries": [
                                                        {
                                                            "type": "Delivery",
                                                            "reference": "24 تا 48 ساعت-1",
                                                            "from": 0,
                                                            "to": 0,
                                                            "title": "24 تا 48 ساعت",
                                                            "deliveryType": "string"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "expired_at": 1672605000
                                        },
                                        {
                                            "id": "2023-01-03-1",
                                            "pickup": {
                                                "from": 1672723800,
                                                "to": 1672741800
                                            },
                                            "routes": [
                                                {
                                                    "type": "Route",
                                                    "route": "تهران-تهران",
                                                    "deliveries": [
                                                        {
                                                            "type": "Delivery",
                                                            "reference": "24 تا 48 ساعت-1",
                                                            "from": 0,
                                                            "to": 0,
                                                            "title": "24 تا 48 ساعت",
                                                            "deliveryType": "string"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "expired_at": 1672691400
                                        }
                                    ],
                                    "logo": "https://staging.podro.com/logos/postLogo.png"
                                }
                            ],
                            "paymentOptions": {
                                "sender": [
                                    "cash"
                                ]
                            },
                            "paymentOptionsWithDiscount": {
                                "sender": [
                                    {
                                        "method": "cash",
                                        "discount": 0,
                                        "markup": 0,
                                        "payablePrice": 146255,
                                        "pickupFee": 0,
                                        "canUse": true
                                    }
                                ]
                            }
                        },
                        "paymentOptions": {
                            "sender": [
                                "cash",
                                "pasargad",
                                "pod"
                            ]
                        },
                        "paymentOptionsWithDiscount": {
                            "sender": [
                                {
                                    "method": "cash",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 249000,
                                    "pickupFee": 0,
                                    "canUse": true
                                },
                                {
                                    "method": "pasargad",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 249000,
                                    "pickupFee": 0,
                                    "canUse": true
                                },
                                {
                                    "method": "pod",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 249000,
                                    "pickupFee": 0,
                                    "canUse": true
                                }
                            ]
                        },
                        "alternativePaymentOptions": {
                            "sender": [
                                "cash"
                            ]
                        },
                        "alternativePaymentOptionsWithDiscount": {
                            "sender": [
                                {
                                    "method": "cash",
                                    "discount": 0,
                                    "markup": 0,
                                    "payablePrice": 395255,
                                    "pickupFee": 0,
                                    "canUse": true
                                }
                            ]
                        }
                    }
                ]
            }
        ],
        "message": ""
    }
}

export const cartShipmentInfosPostJson = {
    "payload": {
        "groupId": "cs3109195yz",
        "paymentLink": null
    },
    "message": ""
}
export const cartDeleteItemsJson = {
    "payload": [],
    "message": "Item is deleted."
}
export const OrderCancelJson = {
    "payload": [],
    "message": "عملیات با موفقیت انجام شد"
}
export const OrderCanBeCancelJson = {
    "payload": [
        {
            "code": "link",
            "name": "لینک اکسپرس",
            "logo": "https://portal.podro.com/logos/linkLogo.png",
            "can_be_canceled": 0,
            "can_be_pending_cancellation": 9,
            "can_not_be_cancelled": 0
        },
        {
            "code": "speed",
            "name": "اسپید",
            "logo": "https://portal.podro.com/logos/speedLogo.png",
            "can_be_canceled": 1,
            "can_be_pending_cancellation": 0,
            "can_not_be_cancelled": 0
        },
        {
            "code": "ecopeyk",
            "name": "اکوپیک",
            "logo": "https://portal.podro.com/logos/ecopeykLogo.png",
            "can_be_canceled": 38,
            "can_be_pending_cancellation": 0,
            "can_not_be_cancelled": 0
        }
    ],
    "message": "success"
}
export const canUseCodJson = {
    "payload": {
        "canUseCod": false,
        "providers": []
    },
    "message": "عملیات با موفقیت انجام شد"
}
const cartItemsBulkJson = {
    "payload": [
        {
            "id": "b24d0359-b9fe-4b77-a9bd-839d559be0e5",
            "sender": {
                "firstName": "محدثه",
                "lastName": "ایرانی",
                "phone": "09300183181",
                "nationalCode": "",
                "postalCode": "1921481221",
                "cityCode": "2301",
                "address": "استان تهران،تهران،خیابان اجاره دار،کوچه شایقی،،بن بست کمال پور",
                "plate": "",
                "unit": "",
                "latitude": null,
                "longitude": null,
                "saveAddressAs": null
            },
            "receiver": {
                "firstName": "شقایق",
                "lastName": "حسینی",
                "phone": "09121111111",
                "nationalCode": "",
                "postalCode": "1111111111",
                "cityCode": "2301",
                "address": "بزرگراه ستاری، خ پیامبر مرکزی، خ هجرت، کوچه اوردی خانی پلاک 2 واحد 6",
                "plate": "",
                "unit": "",
                "latitude": null,
                "longitude": null,
                "saveAddressAs": null
            },
            "parcels": [
                {
                    "weight": {
                        "value": 200,
                        "unit": "G"
                    },
                    "value": {
                        "amount": 10000,
                        "currency": "IRT"
                    },
                    "content": "کارت",
                    "boxSize": "d6112963-08d3-426e-9c90-83e958dbfd53"
                }
            ],
            "description": null
        },
        {
            "id": "d3dd3ed0-3cfb-4bde-8f32-4308c7cd34e7",
            "sender": {
                "firstName": "محدثه",
                "lastName": "ایرانی",
                "phone": "09300183181",
                "nationalCode": "",
                "postalCode": "1921481221",
                "cityCode": "2301",
                "address": "استان تهران،تهران،خیابان اجاره دار،کوچه شایقی،،بن بست کمال پور",
                "plate": "",
                "unit": "",
                "latitude": null,
                "longitude": null,
                "saveAddressAs": null
            },
            "receiver": {
                "firstName": "کامران",
                "lastName": "رحمانی",
                "phone": "09121111111",
                "nationalCode": "",
                "postalCode": "1111111111",
                "cityCode": "2301",
                "address": "کارگر شمالی خ چهارم لاین کندرو تقاطع صالحی پ2 ط4  پلاک  واحد",
                "plate": "",
                "unit": "",
                "latitude": null,
                "longitude": null,
                "saveAddressAs": null
            },
            "parcels": [
                {
                    "weight": {
                        "value": 200,
                        "unit": "G"
                    },
                    "value": {
                        "amount": 10000,
                        "currency": "IRT"
                    },
                    "content": "کارت",
                    "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                }
            ],
            "description": null
        },
        {
            "id": "e18422a9-8e65-4f91-a0ec-c9ea09627652",
            "sender": {
                "firstName": "محدثه",
                "lastName": "ایرانی",
                "phone": "09300183181",
                "nationalCode": "",
                "postalCode": "1921481221",
                "cityCode": "2301",
                "address": "استان تهران،تهران،خیابان اجاره دار،کوچه شایقی،،بن بست کمال پور",
                "plate": "",
                "unit": "",
                "latitude": null,
                "longitude": null,
                "saveAddressAs": null
            },
            "receiver": {
                "firstName": "مازیار",
                "lastName": "فلاحی",
                "phone": "09121111111",
                "nationalCode": "",
                "postalCode": "1111111111",
                "cityCode": "2301",
                "address": "شهرک اکباتان فاز2 بلوک2 ورودی1 طبقه اول پ 27 پلاک 27 واحد",
                "plate": "",
                "unit": "",
                "latitude": null,
                "longitude": null,
                "saveAddressAs": null
            },
            "parcels": [
                {
                    "weight": {
                        "value": 200,
                        "unit": "G"
                    },
                    "value": {
                        "amount": 10000,
                        "currency": "IRT"
                    },
                    "content": "کارت",
                    "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                }
            ],
            "description": null
        },
        {
            "id": "4b72c234-ba12-4bc6-a8e4-5d6b74f5307e",
            "sender": {
                "firstName": "محدثه",
                "lastName": "ایرانی",
                "phone": "09300183181",
                "nationalCode": "",
                "postalCode": "1921481221",
                "cityCode": "2301",
                "address": "استان تهران،تهران،خیابان اجاره دار،کوچه شایقی،،بن بست کمال پور",
                "plate": "",
                "unit": "",
                "latitude": null,
                "longitude": null,
                "saveAddressAs": null
            },
            "receiver": {
                "firstName": "یاسر",
                "lastName": "ولی زاد",
                "phone": "09121111111",
                "nationalCode": "",
                "postalCode": "1111111111",
                "cityCode": "0603",
                "address": "اندیمشک-اندیمشک خیابان امام پاساژ جوانان موبایل یاسر  پلاک  واحد",
                "plate": "",
                "unit": "",
                "latitude": null,
                "longitude": null,
                "saveAddressAs": null
            },
            "parcels": [
                {
                    "weight": {
                        "value": 200,
                        "unit": "G"
                    },
                    "value": {
                        "amount": 10000,
                        "currency": "IRT"
                    },
                    "content": "کارت",
                    "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                }
            ],
            "description": null
        },
        {
            "id": "530f722e-3d8f-43bd-b899-8e75babb21bd",
            "sender": {
                "firstName": "محدثه",
                "lastName": "ایرانی",
                "phone": "09300183181",
                "nationalCode": "",
                "postalCode": "1921481221",
                "cityCode": "2301",
                "address": "استان تهران،تهران،خیابان اجاره دار،کوچه شایقی،،بن بست کمال پور",
                "plate": "",
                "unit": "",
                "latitude": null,
                "longitude": null,
                "saveAddressAs": null
            },
            "receiver": {
                "firstName": "فاطمه",
                "lastName": "خرقانی",
                "phone": "09121111111",
                "nationalCode": "",
                "postalCode": "1111111111",
                "cityCode": "2309",
                "address": "شهریار-شهریار شهرک وایین خیابان جویبار کوچه رحمانی پلاک 12 واحد 1 پلاک  واحد",
                "plate": "",
                "unit": "",
                "latitude": null,
                "longitude": null,
                "saveAddressAs": null
            },
            "parcels": [
                {
                    "weight": {
                        "value": 200,
                        "unit": "G"
                    },
                    "value": {
                        "amount": 10000,
                        "currency": "IRT"
                    },
                    "content": "کارت",
                    "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                }
            ],
            "description": null
        },
        {
            "id": "f5bddd1d-b9dc-49d8-8790-cd88933fe9b6",
            "sender": {
                "firstName": "محدثه",
                "lastName": "ایرانی",
                "phone": "09300183181",
                "nationalCode": "",
                "postalCode": "1921481221",
                "cityCode": "2301",
                "address": "استان تهران،تهران،خیابان اجاره دار،کوچه شایقی،،بن بست کمال پور",
                "plate": "",
                "unit": "",
                "latitude": null,
                "longitude": null,
                "saveAddressAs": null
            },
            "receiver": {
                "firstName": "عباس",
                "lastName": "ارام",
                "phone": "09121111111",
                "nationalCode": "",
                "postalCode": "1111111111",
                "cityCode": "0603",
                "address": "کوی ملت خیابان 5 اقبال پلاک 1 ویلایی  پلاک 1 واحد 1",
                "plate": "",
                "unit": "",
                "latitude": null,
                "longitude": null,
                "saveAddressAs": null
            },
            "parcels": [
                {
                    "weight": {
                        "value": 200,
                        "unit": "G"
                    },
                    "value": {
                        "amount": 10000,
                        "currency": "IRT"
                    },
                    "content": "کارت",
                    "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                }
            ],
            "description": null
        },
        {
            "id": "6c59400e-d69f-4760-93e8-2aa5259e5622",
            "sender": {
                "firstName": "محدثه",
                "lastName": "ایرانی",
                "phone": "09300183181",
                "nationalCode": "",
                "postalCode": "1921481221",
                "cityCode": "2301",
                "address": "استان تهران،تهران،خیابان اجاره دار،کوچه شایقی،،بن بست کمال پور",
                "plate": "",
                "unit": "",
                "latitude": null,
                "longitude": null,
                "saveAddressAs": null
            },
            "receiver": {
                "firstName": "حامد",
                "lastName": "بمانی",
                "phone": "09121111111",
                "nationalCode": "",
                "postalCode": "1111111111",
                "cityCode": "0303",
                "address": "مراغه-مراغه کمربندی شرقی کوی متین آپارتمان مهستان طبقه ی 5 واحد 12 پلاک  واحد 12",
                "plate": "",
                "unit": "",
                "latitude": null,
                "longitude": null,
                "saveAddressAs": null
            },
            "parcels": [
                {
                    "weight": {
                        "value": 200,
                        "unit": "G"
                    },
                    "value": {
                        "amount": 10000,
                        "currency": "IRT"
                    },
                    "content": "کارت",
                    "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                }
            ],
            "description": null
        },
        {
            "id": "2846382d-e21a-4817-8b48-e1021af632bf",
            "sender": {
                "firstName": "محدثه",
                "lastName": "ایرانی",
                "phone": "09300183181",
                "nationalCode": "",
                "postalCode": "1921481221",
                "cityCode": "2301",
                "address": "استان تهران،تهران،خیابان اجاره دار،کوچه شایقی،،بن بست کمال پور",
                "plate": "",
                "unit": "",
                "latitude": null,
                "longitude": null,
                "saveAddressAs": null
            },
            "receiver": {
                "firstName": "عبدالرزاق",
                "lastName": "یوسفیان",
                "phone": "09121111111",
                "nationalCode": "",
                "postalCode": "1111111111",
                "cityCode": "1105",
                "address": "ایرانشهر-بلوار مکران- اداره صنعت،معدن و تجارت شهرستان ایرانشهر - واحد صنعت و معدن پلاک  واحد",
                "plate": "",
                "unit": "",
                "latitude": null,
                "longitude": null,
                "saveAddressAs": null
            },
            "parcels": [
                {
                    "weight": {
                        "value": 200,
                        "unit": "G"
                    },
                    "value": {
                        "amount": 10000,
                        "currency": "IRT"
                    },
                    "content": "کارت",
                    "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                }
            ],
            "description": null
        },
        {
            "id": "5fe75583-9b25-47cb-b2f4-2018cd82246c",
            "sender": {
                "firstName": "محدثه",
                "lastName": "ایرانی",
                "phone": "09300183181",
                "nationalCode": "",
                "postalCode": "1921481221",
                "cityCode": "2301",
                "address": "استان تهران،تهران،خیابان اجاره دار،کوچه شایقی،،بن بست کمال پور",
                "plate": "",
                "unit": "",
                "latitude": null,
                "longitude": null,
                "saveAddressAs": null
            },
            "receiver": {
                "firstName": "صدیقه",
                "lastName": "رهنمایی",
                "phone": "09121111111",
                "nationalCode": "",
                "postalCode": "1111111111",
                "cityCode": "2301",
                "address": "نارمک،خیابان سمنگان ،خیابان ارشی،خیابان اسمیپلاک 250 واحد4 پلاک  واحد",
                "plate": "",
                "unit": "",
                "latitude": null,
                "longitude": null,
                "saveAddressAs": null
            },
            "parcels": [
                {
                    "weight": {
                        "value": 200,
                        "unit": "G"
                    },
                    "value": {
                        "amount": 10000,
                        "currency": "IRT"
                    },
                    "content": "کارت",
                    "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                }
            ],
            "description": null
        },
        {
            "id": "9ad971c5-44a6-4252-8f77-c206857cb826",
            "sender": {
                "firstName": "محدثه",
                "lastName": "ایرانی",
                "phone": "09300183181",
                "nationalCode": "",
                "postalCode": "1921481221",
                "cityCode": "2301",
                "address": "استان تهران،تهران،خیابان اجاره دار،کوچه شایقی،،بن بست کمال پور",
                "plate": "",
                "unit": "",
                "latitude": null,
                "longitude": null,
                "saveAddressAs": null
            },
            "receiver": {
                "firstName": "فاطمه",
                "lastName": "رضائیان",
                "phone": "09121111111",
                "nationalCode": "",
                "postalCode": "1111111111",
                "cityCode": "0707",
                "address": "بلوار همت جنوبی خیابان شهید شیخی مجتمع مسکونی فجر بلوک 14واحد 6 پلاک 6 واحد 14",
                "plate": "",
                "unit": "",
                "latitude": null,
                "longitude": null,
                "saveAddressAs": null
            },
            "parcels": [
                {
                    "weight": {
                        "value": 200,
                        "unit": "G"
                    },
                    "value": {
                        "amount": 10000,
                        "currency": "IRT"
                    },
                    "content": "کارت",
                    "boxSize": "cd2f3786-7806-43c0-a695-61e4cc2ee3b9"
                }
            ],
            "description": null
        }
    ],
    "meta": {
        "count": 10,
        "currentPage": 1,
        "lastPage": 5,
        "nextPageUrl": "http://portal.podro.com/cart/items?page=2",
        "pageSize": 10,
        "total": 48
    },
    "message": ""
}



function guidGenerator() {
    let S4 = function () {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}